import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import types for TypeScript integration and type safety
import './types'

// Import all translation resources (embedded in bundle)
import enCommon from './locales/en/common.json'
import enNav from './locales/en/nav.json'
import enForms from './locales/en/forms.json'
import enAccount from './locales/en/account.json'
// Feature-specific namespaces
import enBoard from './locales/en/board.json'
import enChat from './locales/en/chat.json'
import enChatV2 from './locales/en/chatv2.json'
import enDataCatalog from './locales/en/data_catalog.json'
import enExpertKnowledge from './locales/en/expert_knowledge.json'
import enJobs from './locales/en/jobs.json'
import enConnectors from './locales/en/connectors.json'
import enDigitalCoworker from './locales/en/digital_coworker.json'
import enWorkflow from './locales/en/workflow.json'
import enGraphEditor from './locales/en/graph_editor.json'
import enDocumentViewer from './locales/en/document_viewer.json'
import enSettings from './locales/en/settings.json'
import enOnboarding from './locales/en/onboarding.json'
import enHek from './locales/en/hek.json'
import enHekTopic from './locales/en/hek_topic.json'
import enKnowledgeGraph from './locales/en/knowledge_graph.json'
import enHelpAgent from './locales/en/help_agent.json'

// Spanish translations
import esCommon from './locales/es/common.json'
import esNav from './locales/es/nav.json'
import esForms from './locales/es/forms.json'
import esAccount from './locales/es/account.json'

// Spanish feature-specific namespaces
import esBoard from './locales/es/board.json'
import esChat from './locales/es/chat.json'
import esChatV2 from './locales/es/chatv2.json'
import esDataCatalog from './locales/es/data_catalog.json'
import esExpertKnowledge from './locales/es/expert_knowledge.json'
import esJobs from './locales/es/jobs.json'
import esConnectors from './locales/es/connectors.json'
import esDigitalCoworker from './locales/es/digital_coworker.json'
import esWorkflow from './locales/es/workflow.json'
import esGraphEditor from './locales/es/graph_editor.json'
import esDocumentViewer from './locales/es/document_viewer.json'
import esSettings from './locales/es/settings.json'
import esOnboarding from './locales/es/onboarding.json'
import esHek from './locales/es/hek.json'
import esHekTopic from './locales/es/hek_topic.json'
import esKnowledgeGraph from './locales/es/knowledge_graph.json'
import esHelpAgent from './locales/es/help_agent.json'

// Japanese translations
import jaCommon from './locales/ja/common.json'
import jaNav from './locales/ja/nav.json'
import jaForms from './locales/ja/forms.json'
import jaAccount from './locales/ja/account.json'

// Japanese feature-specific namespaces
import jaBoard from './locales/ja/board.json'
import jaChat from './locales/ja/chat.json'
import jaChatV2 from './locales/ja/chatv2.json'
import jaDataCatalog from './locales/ja/data_catalog.json'
import jaExpertKnowledge from './locales/ja/expert_knowledge.json'
import jaJobs from './locales/ja/jobs.json'
import jaConnectors from './locales/ja/connectors.json'
import jaDigitalCoworker from './locales/ja/digital_coworker.json'
import jaWorkflow from './locales/ja/workflow.json'
import jaGraphEditor from './locales/ja/graph_editor.json'
import jaDocumentViewer from './locales/ja/document_viewer.json'
import jaSettings from './locales/ja/settings.json'
import jaOnboarding from './locales/ja/onboarding.json'
import jaHek from './locales/ja/hek.json'
import jaHekTopic from './locales/ja/hek_topic.json'
import jaKnowledgeGraph from './locales/ja/knowledge_graph.json'
import jaHelpAgent from './locales/ja/help_agent.json'

// Portuguese translations
import ptCommon from './locales/pt/common.json'
import ptNav from './locales/pt/nav.json'
import ptForms from './locales/pt/forms.json'
import ptAccount from './locales/pt/account.json'

// Portuguese feature-specific namespaces
import ptBoard from './locales/pt/board.json'
import ptChat from './locales/pt/chat.json'
import ptChatV2 from './locales/pt/chatv2.json'
import ptDataCatalog from './locales/pt/data_catalog.json'
import ptExpertKnowledge from './locales/pt/expert_knowledge.json'
import ptJobs from './locales/pt/jobs.json'
import ptConnectors from './locales/pt/connectors.json'
import ptDigitalCoworker from './locales/pt/digital_coworker.json'
import ptWorkflow from './locales/pt/workflow.json'
import ptGraphEditor from './locales/pt/graph_editor.json'
import ptDocumentViewer from './locales/pt/document_viewer.json'
import ptSettings from './locales/pt/settings.json'
import ptOnboarding from './locales/pt/onboarding.json'
import ptHek from './locales/pt/hek.json'
import ptHekTopic from './locales/pt/hek_topic.json'
import ptKnowledgeGraph from './locales/pt/knowledge_graph.json'
import ptHelpAgent from './locales/pt/help_agent.json'

// Arabic translations
import arCommon from './locales/ar/common.json'
import arNav from './locales/ar/nav.json'
import arForms from './locales/ar/forms.json'
import arAccount from './locales/ar/account.json'

// Arabic feature-specific namespaces
import arBoard from './locales/ar/board.json'
import arChat from './locales/ar/chat.json'
import arChatV2 from './locales/ar/chatv2.json'
import arDataCatalog from './locales/ar/data_catalog.json'
import arExpertKnowledge from './locales/ar/expert_knowledge.json'
import arJobs from './locales/ar/jobs.json'
import arConnectors from './locales/ar/connectors.json'
import arDigitalCoworker from './locales/ar/digital_coworker.json'
import arWorkflow from './locales/ar/workflow.json'
import arGraphEditor from './locales/ar/graph_editor.json'
import arDocumentViewer from './locales/ar/document_viewer.json'
import arSettings from './locales/ar/settings.json'
import arOnboarding from './locales/ar/onboarding.json'
import arHek from './locales/ar/hek.json'
import arHekTopic from './locales/ar/hek_topic.json'
import arKnowledgeGraph from './locales/ar/knowledge_graph.json'
import arHelpAgent from './locales/ar/help_agent.json'

// Supported languages
export const SUPPORTED_LANGUAGES = {
  en: 'English',
  ar: 'العربية',
  ja: '日本語',
  es: 'Español',
  pt: 'Português',
} as const

export type SupportedLanguage = keyof typeof SUPPORTED_LANGUAGES

export const RTL_LANGUAGES: SupportedLanguage[] = ['ar'] as const

export const isRTL = (language: string): boolean => {
  return RTL_LANGUAGES.includes(language as SupportedLanguage)
}

export const getTextDirection = (language: string): 'ltr' | 'rtl' => {
  return isRTL(language) ? 'rtl' : 'ltr'
}

// Default namespace configuration
export const DEFAULT_NAMESPACE = 'common'
export const NAMESPACES = [
  'common',
  'nav',
  'forms',
  'account',
  'board',
  'chat',
  'chatv2',
  'data_catalog',
  'expert_knowledge',
  'jobs',
  'connectors',
  'digital_coworker',
  'workflow',
  'graph_editor',
  'document_viewer',
  'settings',
  'onboarding',
  'hek',
  'hek_topic',
  'knowledge_graph',
  'help_agent',
] as const

// All translation resources (embedded)
const resources = {
  en: {
    common: enCommon,
    nav: enNav,
    forms: enForms,
    account: enAccount,
    // Feature-specific namespaces
    board: enBoard,
    chat: enChat,
    chatv2: enChatV2,
    data_catalog: enDataCatalog,
    expert_knowledge: enExpertKnowledge,
    jobs: enJobs,
    connectors: enConnectors,
    digital_coworker: enDigitalCoworker,
    workflow: enWorkflow,
    graph_editor: enGraphEditor,
    document_viewer: enDocumentViewer,
    settings: enSettings,
    onboarding: enOnboarding,
    hek: enHek,
    hek_topic: enHekTopic,
    knowledge_graph: enKnowledgeGraph,
    help_agent: enHelpAgent,
  },
  es: {
    // Spanish translations
    common: esCommon,
    nav: esNav,
    forms: esForms,
    account: esAccount,
    // Spanish feature-specific namespaces
    board: esBoard,
    chat: esChat,
    chatv2: esChatV2,
    data_catalog: esDataCatalog,
    expert_knowledge: esExpertKnowledge,
    jobs: esJobs,
    connectors: esConnectors,
    digital_coworker: esDigitalCoworker,
    workflow: esWorkflow,
    graph_editor: esGraphEditor,
    document_viewer: esDocumentViewer,
    settings: esSettings,
    onboarding: esOnboarding,
    hek: esHek,
    hek_topic: esHekTopic,
    knowledge_graph: esKnowledgeGraph,
    help_agent: esHelpAgent,
  },
  ja: {
    // Japanese translations
    common: jaCommon,
    nav: jaNav,
    forms: jaForms,
    account: jaAccount,
    // Japanese feature-specific namespaces
    board: jaBoard,
    chat: jaChat,
    chatv2: jaChatV2,
    data_catalog: jaDataCatalog,
    expert_knowledge: jaExpertKnowledge,
    jobs: jaJobs,
    connectors: jaConnectors,
    digital_coworker: jaDigitalCoworker,
    workflow: jaWorkflow,
    graph_editor: jaGraphEditor,
    document_viewer: jaDocumentViewer,
    settings: jaSettings,
    onboarding: jaOnboarding,
    hek: jaHek,
    hek_topic: jaHekTopic,
    knowledge_graph: jaKnowledgeGraph,
    help_agent: jaHelpAgent,
  },
  pt: {
    // Portuguese translations
    common: ptCommon,
    nav: ptNav,
    forms: ptForms,
    account: ptAccount,
    // Portuguese feature-specific namespaces
    board: ptBoard,
    chat: ptChat,
    chatv2: ptChatV2,
    data_catalog: ptDataCatalog,
    expert_knowledge: ptExpertKnowledge,
    jobs: ptJobs,
    connectors: ptConnectors,
    digital_coworker: ptDigitalCoworker,
    workflow: ptWorkflow,
    graph_editor: ptGraphEditor,
    document_viewer: ptDocumentViewer,
    settings: ptSettings,
    onboarding: ptOnboarding,
    hek: ptHek,
    hek_topic: ptHekTopic,
    knowledge_graph: ptKnowledgeGraph,
    help_agent: ptHelpAgent,
  },
  ar: {
    // Arabic translations
    common: arCommon,
    nav: arNav,
    forms: arForms,
    account: arAccount,
    // Arabic feature-specific namespaces
    board: arBoard,
    chat: arChat,
    chatv2: arChatV2,
    data_catalog: arDataCatalog,
    expert_knowledge: arExpertKnowledge,
    jobs: arJobs,
    connectors: arConnectors,
    digital_coworker: arDigitalCoworker,
    workflow: arWorkflow,
    graph_editor: arGraphEditor,
    document_viewer: arDocumentViewer,
    settings: arSettings,
    onboarding: arOnboarding,
    hek: arHek,
    hek_topic: arHekTopic,
    knowledge_graph: arKnowledgeGraph,
    help_agent: arHelpAgent,
  },
}

// i18next configuration
const i18nConfig = {
  // Fallback language
  fallbackLng: 'en',

  // Supported languages
  supportedLngs: Object.keys(SUPPORTED_LANGUAGES),

  // Default namespace - load all namespaces by default
  defaultNS: NAMESPACES,

  // Available namespaces
  ns: NAMESPACES,

  // Language detection configuration
  detection: {
    // Detection order: localStorage -> navigator language -> fallback
    order: ['localStorage', 'navigator', 'htmlTag'],
    // Cache user language preference
    caches: ['localStorage'],
    // localStorage key
    lookupLocalStorage: 'i18nextLng',
    // Check for supported languages only
    checkWhitelist: true,
  },

  // Interpolation settings
  interpolation: {
    // React already escapes values
    escapeValue: false,
    // Format function for dates, numbers, etc.
    format: (value: unknown, format?: string, lng?: string) => {
      if (format === 'uppercase') return String(value).toUpperCase()
      if (format === 'lowercase') return String(value).toLowerCase()

      // Date formatting
      if (format === 'date' && value instanceof Date) {
        return new Intl.DateTimeFormat(lng).format(value)
      }

      // Number formatting
      if (format === 'number' && typeof value === 'number') {
        return new Intl.NumberFormat(lng).format(value)
      }

      return String(value)
    },
  },

  // React-specific settings
  react: {
    // Don't use Suspense since we have all resources embedded
    useSuspense: false,
    // Bind i18n instance to component
    bindI18n: 'languageChanged',
    // Bind i18n store to component
    bindI18nStore: 'added removed',
    // Translate missing keys
    transEmptyNodeValue: '',
    // Keep translation keys as fallback
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'em', 'span'],
  },

  // Resource loading settings
  load: 'languageOnly' as const, // Load 'en' instead of 'en-US'

  // Pluralization
  pluralSeparator: '_',
  contextSeparator: '_',

  // Missing key handling (disable in tests)
  saveMissing: import.meta.env.DEV && !import.meta.env.VITEST,
  missingKeyHandler:
    import.meta.env.DEV && !import.meta.env.VITEST
      ? (lngs: readonly string[], ns: string, key: string) => {
          console.warn(
            `Missing translation key: ${ns}:${key} for languages: ${lngs.join(
              ', '
            )}`
          )
        }
      : undefined,

  // Embedded resources
  resources,
}

// Initialize i18next
i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n down to react-i18next
  .init(i18nConfig)

// Export configured instance
export default i18n

// Helper functions
export const getCurrentLanguage = (): SupportedLanguage => {
  const currentLng = i18n.language || 'en'
  return (
    Object.keys(SUPPORTED_LANGUAGES).includes(currentLng) ? currentLng : 'en'
  ) as SupportedLanguage
}

export const changeLanguage = async (lng: SupportedLanguage): Promise<void> => {
  // Update document direction when language changes
  const direction = getTextDirection(lng)
  document.documentElement.dir = direction
  document.documentElement.lang = lng
  
  await i18n.changeLanguage(lng)
}

export const getLanguageDisplayName = (lng: SupportedLanguage): string => {
  return SUPPORTED_LANGUAGES[lng]
}

export const getCurrentDirection = (): 'ltr' | 'rtl' => {
  return getTextDirection(getCurrentLanguage())
}
